import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pushShowCard, pushShowTable, deleteChipArrayAddCriteria, deleteChip, pushEntity, pushAddCriteriaCard, pushName, isFilterCleared, applyingNewFilter } from '../../slices/customQueryBodySlice';
import { pushEnableClearAll, showContextualPath, pushPostApiResponse, pushTableData } from '../../slices/customQueryHeaderSlice';
import consts from '../../utils/consts';
import { StyledLabel, StyledLabelGrid, StyledGrid, StyledBody, StyledCardBody, StyledChip, StyledCustomLinkButton, StyledLinkButton, StyledTextGrid } from './DefineQueryStyle';
import { parseChipArray } from '../../utils/utils';

const DefineQuery = () => {
  const {
    operationsNamesArray,
    userAccountOperations
  } = consts;
  let parsedChipArray = [];
  const selectedChipArray = useSelector(state => state.customQueryBody.ChipArrayAddCriteria);
  const enableClearAll = useSelector(state => state.customQueryHeader.enableClearAll);
  const showCriteriaCard = useSelector(state => state.customQueryBody.showCriteriaCard);
  const selectedEntity = useSelector(state => state.customQueryHeader.selectedDataType);
  const dispatch = useDispatch();

  const onAddCriteria = () => {
    dispatch(showContextualPath(true));
    dispatch(pushAddCriteriaCard(false));
    dispatch(pushShowCard(true));
    dispatch(pushShowTable(false));
    dispatch(pushEntity([]));
    dispatch(pushName(''));
    dispatch(isFilterCleared(false));
    dispatch(applyingNewFilter(false));
  };

  const onCancel = () => {
    onChipClear(true);
    dispatch(showContextualPath(false));
    dispatch(deleteChipArrayAddCriteria([]));
    dispatch(pushEnableClearAll(false));
    dispatch(pushAddCriteriaCard(true));
  };

  const onChipClear = last => {
    let data = {
      data: '',
      type: 'run'
    };
    dispatch(pushPostApiResponse(data));
    let savedata = {
      data: '',
      type: 'save'
    };
    dispatch(pushPostApiResponse(savedata));
    let queryResults = {
      data: [],
      totalCount: 0,
      totalPages: 0
    };
    dispatch(pushTableData(queryResults));
    dispatch(pushShowTable(false));
    dispatch(pushShowCard(false));
    dispatch(last ? isFilterCleared(true) : applyingNewFilter(true));
  };

  parsedChipArray = parseChipArray(selectedChipArray, operationsNamesArray, userAccountOperations);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showCriteriaCard && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledBody, {
    container: true
  }, /*#__PURE__*/React.createElement(StyledLabelGrid, null, /*#__PURE__*/React.createElement(StyledLabel, null, "Filters")), /*#__PURE__*/React.createElement(StyledTextGrid, null, /*#__PURE__*/React.createElement(StyledCardBody, null, parsedChipArray && parsedChipArray.length > 0 ? parsedChipArray.map((item, index) => {
    let chipLabel = `${item.entityName} ${item.entityOpr} ${item.entityValue}`;

    if (index === parsedChipArray.length - 1) {
      return /*#__PURE__*/React.createElement(StyledChip, {
        key: index,
        label: chipLabel,
        onDelete: () => {
          onChipClear(index === 0);
          dispatch(showContextualPath(false));
          dispatch(deleteChip(item));
        }
      });
    } else {
      return /*#__PURE__*/React.createElement("span", {
        key: index
      }, /*#__PURE__*/React.createElement(StyledChip, {
        key: index,
        label: chipLabel,
        onDelete: () => {
          onChipClear(false);
          dispatch(deleteChip(item));
        }
      }), /*#__PURE__*/React.createElement("span", null, "AND"));
    }
  }) : null)), /*#__PURE__*/React.createElement(StyledGrid, null, /*#__PURE__*/React.createElement(StyledCustomLinkButton, {
    onClick: onAddCriteria,
    disabled: !selectedEntity
  }, "Add Criteria"), /*#__PURE__*/React.createElement(StyledLinkButton, {
    onClick: onCancel,
    disabled: !enableClearAll
  }, "Clear All")))));
};

export default DefineQuery;